export default __webpack_public_path__ + "static/musabuffa-logo-small-5e0baf5f80253213366cab77ea5afb30.png";